import { render, staticRenderFns } from "./TopbTable.vue?vue&type=template&id=64420b31&scoped=true"
import script from "./TopbTable.vue?vue&type=script&lang=ts"
export * from "./TopbTable.vue?vue&type=script&lang=ts"
import style0 from "./TopbTable.vue?vue&type=style&index=0&id=64420b31&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64420b31",
  null
  
)

export default component.exports